require('./bootstrap');
import $ from 'jquery';
window.$ = window.jQuery = $;

require('maximize-select2-height');

import 'jquery-ui/ui/widgets/autocomplete.js';
import 'jquery-ui/ui/widgets/resizable.js';
import 'jquery-ui/ui/widgets/sortable.js';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// import '@fortawesome/fontawesome-free/js/all.js';

//import 'bootbox/dist/bootbox.min.js';
/*import * as bootbox from 'bootbox';
import 'bootbox/dist/bootbox.locales.min.js';
window.bootbox = bootbox;*/

import Chart from 'chart.js/auto';
window.Chart = Chart;

require('select2');
require('select2/dist/js/i18n/fr');

import {
    Toaster,
    ToasterPosition,
    ToasterTimer,
    ToasterType,
} from "bs-toaster";
window.Toaster = Toaster;
window.ToasterPosition = ToasterPosition;
window.ToasterTimer = ToasterTimer;
window.ToasterType = ToasterType;
